document.addEventListener("DOMContentLoaded", function() {
  bindCustomProductCardVariantChange();
});

function bindCustomProductCardVariantChange() {
  const customProductCardVariants = document.querySelectorAll('.custom-product-card-product-price-dropdown');
  if (customProductCardVariants.length) {
    customProductCardVariants.forEach(function(customProductCardVariant) {
      customProductCardVariant.addEventListener('change', function() {
        const targetProductVariantId = this.value;
        const targetProductVariant = this.options[this.selectedIndex];
        const targetProductVariantAvailability = targetProductVariant.getAttribute('data-available');
        const targetProductcard = this.closest('.custom-product-card-wrapper');
        if (targetProductcard) {
          const targetAddToCartForm = targetProductcard.querySelector('form');
          if (targetAddToCartForm) {
            const targetAddToCartFormIdElement = targetAddToCartForm.querySelector('[name="id"]');
            if (targetAddToCartFormIdElement) {
              targetAddToCartFormIdElement.value = targetProductVariantId;
              targetAddToCartFormIdElement.disabled = false;
            }

            const targetAddToCartFormAddElement = targetAddToCartForm.querySelector('[name="add"]');
            if (targetAddToCartFormAddElement) {
              targetAddToCartFormAddElement.disabled = false;
            }

            const targetAddToCartBtnMsg = targetAddToCartForm.querySelector('.custom-product-card-add-to-cart-button-message');
            if (targetAddToCartBtnMsg) {
              targetAddToCartBtnMsg.innerHTML = targetAddToCartBtnMsg.getAttribute("data-add-to-cart") || "Add to cart";
            }

            if (targetProductVariantAvailability != "true") {
              if (targetAddToCartFormIdElement) {
                targetAddToCartFormIdElement.disabled = true;
              }

              if (targetAddToCartFormAddElement) {
                targetAddToCartFormAddElement.disabled = true;
              }

              if (targetAddToCartBtnMsg) {
                targetAddToCartBtnMsg.innerHTML = targetAddToCartBtnMsg.getAttribute("data-sold-out") || "Sold out";
              }
            }
          }
        }
      });
    });
  }
}
(() => {
  const initialized = new WeakSet();

  function initCustomSelect(wrapper) {
    if (initialized.has(wrapper)) return;

    const customSelected = wrapper.querySelector(".custom-selected");
    const customOptions  = wrapper.querySelector(".custom-options");
    const options        = wrapper.querySelectorAll(".custom-option");
    const hiddenSelect   = wrapper.querySelector(".custom-product-card-product-price-dropdown");

    // if essential elements are missing, wait and retry
    if (!customSelected || !customOptions || !options.length || !hiddenSelect) {
      return; // skip for now, observer will retry when more children arrive
    }

    initialized.add(wrapper);

    function updateSelected(optionEl) {
      options.forEach(o => o.classList.remove("selected"));
      optionEl.classList.add("selected");

      const variantTitle  = optionEl.querySelector("p")?.innerHTML.trim() || optionEl.textContent.trim();
      const originalPrice = optionEl.querySelector(".original-price")?.outerHTML || "";
      const salePrice     = optionEl.querySelector(".sale-price")?.outerHTML     || "";

      customSelected.innerHTML = `
        <p>${variantTitle}</p>
        ${originalPrice}
        ${salePrice}
      `;

      hiddenSelect.value = optionEl.getAttribute("data-value");
      hiddenSelect.dispatchEvent(new Event("change"));
    }

    if (options.length > 0) updateSelected(options[0]);

    customSelected.addEventListener("click", e => {
      e.stopPropagation();
      customOptions.classList.toggle("open");
    });

    options.forEach(opt => {
      opt.addEventListener("click", e => {
        e.stopPropagation();
        updateSelected(opt);
        customOptions.classList.remove("open");
      });
    });
  }

  function scanAndInit() {
    document.querySelectorAll(".custom-select-wrapper").forEach(initCustomSelect);
  }

  document.addEventListener("click", () => {
    document.querySelectorAll(".custom-options.open").forEach(menu => menu.classList.remove("open"));
  });

  if (document.readyState !== "loading") scanAndInit();
  else document.addEventListener("DOMContentLoaded", scanAndInit);

  const mo = new MutationObserver(mutations => {
    for (let { addedNodes } of mutations) {
      addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches(".custom-select-wrapper")) {
          initCustomSelect(node);
        }

        node.querySelectorAll?.(".custom-select-wrapper").forEach(initCustomSelect);
      });
    }
  });

  mo.observe(document.body, { childList: true, subtree: true });
})();

